import { FaWifi, FaTv, FaMobileAlt } from 'react-icons/fa';
import { images } from '../constants';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icons: [<FaWifi />],
    title: 'Basic Plan',
    subtitle: 'Internet Only',
    speed: '35',
    price: 29.99,
    features: [
      'High-Speed Internet',
      'Free Installation',
      '24/7 Customer Support',
      'No Data Caps',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icons: [<FaWifi />, <FaTv />],
    title: 'Standard Plan',
    subtitle: 'Internet + Cable TV',
    speed: '75',
    price: 59.99,
    features: [
      'Up to 120+ Channels',
      'High-Speed Internet',
      'Free HD Channels',
      'Unlimited Streaming',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icons: [<FaWifi />, <FaTv />, <FaMobileAlt />],
    title: 'Premium Plan',
    subtitle: 'Internet + TV + Mobile',
    speed: '150',
    price: 99.99,
    features: [
      'Up to 200+ Channels',
      'High-Speed Internet',
      'Mobile Connectivity',
      'On-Demand Movies',
    ],
  },
];

export default pricing;